import React, { memo } from 'react';

import { HorizontalCardList } from '~/components/HorizontalCardList/HorizontalCardList';

import type { IContentList } from './ContentList.types';

const ContentListComponent = (props: IContentList) => {
  const { contentRows, onRowFocus, onProgramFocus, onProgramSelect } = props;

  return (
    <>
      {contentRows?.map((row, index) => (
        <HorizontalCardList
          key={row.id}
          title={row.name}
          onBecameFocused={onRowFocus}
          isContentLazy={index > 1}
          cards={row.cards.map((card) => ({
            id: card.id,
            imageURL: card.imageURL,
            name: card.name,
            programData: card,
            onSelectCard: () => onProgramSelect(card.id),
            onFocus: () => onProgramFocus(card.programData),
          }))}
        />
      ))}
    </>
  );
};

export const ContentList = memo(ContentListComponent);
